// extracted by mini-css-extract-plugin
module.exports = {"orderPlaced":"subscriptionPlaced_orderPlaced__2SAkD","confomation":"subscriptionPlaced_confomation__3bFBY"};